/// <amd-dependency path='VSS/LoaderPlugins/Css!TestManagement' />

import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import TFS_OM_Common_LAZY_LOAD = require("Presentation/Scripts/TFS/TFS.OM.Common");
import TestsOM_LAZY_LOAD = require("TestManagement/Scripts/TFS.TestManagement");

export interface IMoveTestCaseToSuiteProxyProps {
    tfsContext: any
    planId: number;
    sourceSuiteId: number;
    destinationSuiteId: number;
    sourceSuiteRevision: number;
    destinationSuiteRevision: number;
    testCaseIds: number[];
    successCallBack: (moveTestCasesSuccessful: boolean) => void;
    errorCallBack: (string) => void;
}

// This is a proxy component to use MVC api for moving test cases to different suite in test hub refresh
class MoveTestCaseToSuiteProxy extends React.Component<IMoveTestCaseToSuiteProxyProps, {}> {
    public render(): React.ReactNode {
        return <div />;
    }

    public componentDidMount(): void {
        let testPlanManager = TFS_OM_Common_LAZY_LOAD.ProjectCollection.getConnection(this.props.tfsContext).getService(TestsOM_LAZY_LOAD.TestPlanManager);
        const movedTestCasesPosition = 0;
        testPlanManager.moveTestSuiteEntry(
            this.props.planId,
            this.props.sourceSuiteId,
            this.props.sourceSuiteRevision,
            this.props.destinationSuiteId,
            this.props.destinationSuiteRevision,
            this.props.testCaseIds,
            true,
            movedTestCasesPosition,
            this.props.successCallBack,
            this.props.errorCallBack);
    }
}

registerLWPComponent("move-test-case-to-suite-proxy", MoveTestCaseToSuiteProxy);
